import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, selectors } from '../ducks';
import NotificationsTrigger from './presenter';
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actionCreators, dispatch) });

const mapStateToProps = (state, props) => {
    return {
        showDropdown: selectors.getShowNotificationsDropdown(state),
        hasAlert: !!selectors.getCount(state),
        count: selectors.getCount(state),
        ...props,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsTrigger);
